import { useLocation } from 'react-router-dom'

import { Header } from 'components/app-shell/Header'
import { getBreadcrumbLabel } from 'constants/breadcrumbs'

import type { ReactNode } from 'react'

interface AppLayoutProperties {
  children: ReactNode
}

export const AppLayout = ({ children }: AppLayoutProperties) => {
  /* --- Section 1: Hooks --- */
  const location = useLocation()

  /* --- Section 3: Derived Values --- */
  const breadcrumb = getBreadcrumbLabel(location.pathname)

  const isLandingPage = location.pathname === '/new'
  const showHeader = !isLandingPage

  /* --- Section 6: Render --- */
  return (
    <div className="App">
      {showHeader ? <Header breadcrumb={breadcrumb} /> : null}
      {children}
    </div>
  )
}
